import { useLingui } from '@lingui/react/macro'

import { MemberList } from '@/features/membership'
import { DialogHeader } from '@/layouts/Dialog'

const OrganizationMembers: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader
        title={t`Members`}
        description={t`Edit Members of the Hotel`}
      />
      <MemberList />
    </div>
  )
}

export default OrganizationMembers
